export type EditorContentStatus = 'current' | 'archived' | 'draft';

// Returns the published node for a published page and the draft node for a never-published one.
// Order matters: it is part of the Relay root storage key.
export const EDITOR_CONTENT_STATUSES: readonly EditorContentStatus[] = [
	'current',
	'archived',
	'draft',
];

export type EditorContentUnifiedQueryVariableOptions = {
	contentId: string;
	draftShareId?: string | null;
	status?: readonly EditorContentStatus[];
	spaceKey?: string | null;
	versionOverride?: number | null;
	isSSR?: boolean;
};

export type EditorContentUnifiedQueryVariables = {
	contentId: string;
	status: readonly EditorContentStatus[];
	draftShareId?: string;
	spaceKey?: string | null;
	versionOverride?: number | null;
	isSSR?: boolean;
};

export const createEditorContentUnifiedQueryVariables = ({
	contentId,
	draftShareId,
	status = EDITOR_CONTENT_STATUSES,
	spaceKey,
	versionOverride,
	isSSR,
}: EditorContentUnifiedQueryVariableOptions): EditorContentUnifiedQueryVariables => ({
	contentId,
	status,
	// "" would stay in the storage key and cost the backend a permission check; omit instead
	...(draftShareId ? { draftShareId } : {}),
	...(spaceKey !== undefined ? { spaceKey } : {}),
	...(versionOverride !== undefined ? { versionOverride } : {}),
	...(isSSR !== undefined ? { isSSR } : {}),
});
